import React, { useState } from 'react';
import { Box } from '@mui/material';
import useMediaQuery from '@mui/system/useMediaQuery';
import colors from '../../theme/colors';
import { breakpoints } from '../../theme';
import * as T from '../Typography';
import { DownloadSurveyCardWrapper, IconWrapper } from './style';
import Button from '../Button';
import fileDocIcon from '../assets/file-doc.svg';
import DownloadSurveyConfirmModal from '../DownloadSurveyConfirmModal';
import { formatDate } from '../../helpers/format-date';

const DownloadSurveyCard: React.FC<{ endDate: String }> = ({ endDate }) => {
  const [showModal, setShowModal] = useState(false);
  const isWideScreen = useMediaQuery(`(min-width:${breakpoints.tablet}px)`);

  return (
    <DownloadSurveyCardWrapper>
      <Box>
        <IconWrapper>
          <img src={fileDocIcon} alt="Survey Icon" />
        </IconWrapper>
        <Box
          flex={1}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          mb={isWideScreen ? 0 : 3}
        >
          <T.TextMediumBold color={colors.neutral.shades.shade700}>
            Download survey for offline viewing
          </T.TextMediumBold>
          <Box>
            <T.TextSmallRegular
              mt={2}
              mb={3}
              color={colors.neutral.shades.shade600}
            >
              You can download the survey to complete offline, but please
              remember that you will still need to submit your responses via the
              form in the online portal before the deadline on{' '}
              {formatDate(endDate)}.
            </T.TextSmallRegular>
            <Button
              variant="blue"
              decoration="none"
              handleClick={() => setShowModal(!showModal)}
              width={'fit-content'}
            >
              Download now
            </Button>
          </Box>
        </Box>
      </Box>
      <DownloadSurveyConfirmModal
        visible={showModal}
        setIsModalVisible={() => setShowModal(!showModal)}
      />
    </DownloadSurveyCardWrapper>
  );
};

export default DownloadSurveyCard;
